// extracted by mini-css-extract-plugin
export var content = "HeroBannerUrgentMessageSlide-module--content--e04cf";
export var slideBackgroundSolid = "HeroBannerUrgentMessageSlide-module--slide-background-solid--3a1ec";
export var title = "HeroBannerUrgentMessageSlide-module--title--35791";
export var topContent = "HeroBannerUrgentMessageSlide-module--top-content--07ca0";